import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'sm-spinner',
  standalone: true,
  imports: [ProgressSpinnerModule, CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {
  @Input() loading: Observable<boolean> | boolean = of(true);
  @Input() class = '';

  get loading$(): Observable<boolean> {
    return typeof this.loading === 'boolean' ? of(this.loading) : this.loading;
  }
}
